import { render, staticRenderFns } from "./Lowcarbon.vue?vue&type=template&id=366b1d8a&scoped=true"
import script from "./Lowcarbon.vue?vue&type=script&lang=js"
export * from "./Lowcarbon.vue?vue&type=script&lang=js"
import style0 from "./Lowcarbon.vue?vue&type=style&index=0&id=366b1d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b1d8a",
  null
  
)

export default component.exports